import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/communitymanagement/brandloyalty.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/communitymanagement/brandpresence.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/communitymanagement/customersatisfaction.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/communitymanagement/customersupport.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/communitymanagement/datadriven.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/communitymanagement/educational.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/communitymanagement/insights.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/communitymanagement/interactivecontent.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/communitymanagement/onlinecommunity.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/communitymanagement/socialmedia.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/DataCollectionMobileCarousel/index.tsx");
